__turbopack_context__.v({
  "root": "Fdeyma_root",
});
